// extracted by mini-css-extract-plugin
export var explainable = "_j2-a";
export var printerCard = "_j2-1";
export var printerCardConfigured = "_j2-2";
export var printerCardError = "_j2-3";
export var printerCardsContainer = "_j2-0";
export var printerIcon = "_j2-8";
export var printerIconConfigured = "_j2-5";
export var printerIconContainer = "_j2-4";
export var printerIconError = "_j2-6";
export var printerIconUnconfigured = "_j2-7";
export var workstationsTableCard = "_j2-9";